import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import "../../assets/css/styles.css";
import {useSelector} from "react-redux";
import { Navbar, Nav, Container, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import PopupComponent from "../../components/PopupComponent";
const HomePage = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const history = useHistory();
  const userData = useSelector((state) => state.user);


  useEffect(() => {
    if (Object.keys(userData.user).length > 0) {
      setIsLoggedIn(true);
    }
  }, [userData]);
  const handleLoginSuccess = (token) => {
    localStorage.setItem("user", token);
    setIsLoggedIn(true);
    history.push("/");
  };


/*  useEffect(() => {
    const token = localStorage.getItem("token");
    setIsLoggedIn(!!token);
  }, []);*/




  const handleLoginRedirect = () => {
    history.push("/login");
  };

  // Load fonts and icons
  useEffect(() => {
    const googleFont = document.createElement("link");
    googleFont.href =
      "https://fonts.googleapis.com/css2?family=Public+Sans:ital,wght@0,100..900;1,100..900&display=swap";
    googleFont.rel = "stylesheet";

    const fontAwesome = document.createElement("link");
    fontAwesome.href =
      "https://cdn.jsdelivr.net/npm/@fortawesome/fontawesome-free@6.5.2/css/all.min.css";
    fontAwesome.rel = "stylesheet";

    document.head.append(googleFont, fontAwesome);
    return () => {
      document.head.removeChild(googleFont);
      document.head.removeChild(fontAwesome);
    };
  }, []);

  // Main banner slider
  useEffect(() => {
    const slides = document.querySelectorAll(".slide-item");
    const slider = document.querySelector(".main-slider");
    const dots = document.querySelectorAll(".slider-indicators .indicator");
    const transitionMode = "slide";

    if (!slider || slides.length === 0) return;

    if (transitionMode === "fade") {
      slider.classList.add("slider-fade");
      slides[0].classList.add("active");
    } else {
      slider.classList.add("slider-slide");
    }

    let currentSlide = 0;

    const updateDots = (index) => {
      dots.forEach((d, i) => d.classList.toggle("active", i === index));
    };

    const showSlide = (index) => {
      if (transitionMode === "fade") {
        slides.forEach((s, i) => s.classList.toggle("active", i === index));
      } else {
        slider.style.transform = `translateX(-${index * 100}%)`;
      }
      updateDots(index);
    };

    const nextSlide = () => {
      currentSlide = (currentSlide + 1) % slides.length;
      showSlide(currentSlide);
    };

    let intervalId = null;
    const startAutoPlay = () => {
      clearInterval(intervalId);
      intervalId = setInterval(nextSlide, 12000);
    };
    const stopAutoPlay = () => clearInterval(intervalId);

    showSlide(currentSlide);
    startAutoPlay();

    const handleMouseEnter = () => stopAutoPlay();
    const handleMouseLeave = () => startAutoPlay();
    slider.addEventListener("mouseenter", handleMouseEnter);
    slider.addEventListener("mouseleave", handleMouseLeave);

    const dotHandlers = [];
    dots.forEach((dot, idx) => {
      const clickHandler = () => {
        stopAutoPlay();
        currentSlide = idx;
        showSlide(currentSlide);
        startAutoPlay();
      };
      dot.addEventListener("click", clickHandler);
      dotHandlers.push(clickHandler);
    });

    return () => {
      stopAutoPlay();
      slider.removeEventListener("mouseenter", handleMouseEnter);
      slider.removeEventListener("mouseleave", handleMouseLeave);
      dots.forEach((dot, i) =>
        dot.removeEventListener("click", dotHandlers[i])
      );
    };
  }, []);

  // Collaborators carousel
  useEffect(() => {
    const slider = document.querySelector(".authority-slider");
    const prevBtn = document.querySelector(".carousel-btn.prev");
    const nextBtn = document.querySelector(".carousel-btn.next");
    const items = document.querySelectorAll(".auth-item");
    const visible = 4;
    if (!slider || items.length === 0) return;

    let idx = 0,
      startX = 0,
      baseX = 0,
      drag = false;
    const itemW = () => items[0].offsetWidth;

    const update = () => {
      slider.style.transition = "transform 0.4s ease";
      slider.style.transform = `translateX(-${idx * itemW()}px)`;
    };

    let autoId;
    const start = () => {
      clearInterval(autoId);
      autoId = setInterval(() => {
        idx = idx < items.length - visible ? idx + 1 : 0;
        update();
      }, 3000);
    };
    const stop = () => clearInterval(autoId);

    const getX = (e) => (e.touches ? e.touches[0].clientX : e.pageX);
    const dragStart = (e) => {
      drag = true;
      startX = getX(e);
      baseX =
        parseFloat(getComputedStyle(slider).transform.split(",")[4]) || 0;
      slider.style.transition = "none";
      stop();
    };
    const dragMove = (e) => {
      if (!drag) return;
      const dx = getX(e) - startX;
      slider.style.transform = `translateX(${baseX + dx}px)`;
    };
    const dragEnd = () => {
      if (!drag) return;
      drag = false;
      const moved =
        (parseFloat(getComputedStyle(slider).transform.split(",")[4]) || 0) -
        baseX;
      if (moved < -50 && idx < items.length - visible) idx++;
      if (moved > 50 && idx > 0) idx--;
      update();
      start();
    };

    prevBtn.onclick = () => {
      if (idx > 0) idx--;
      update();
    };
    nextBtn.onclick = () => {
      if (idx < items.length - visible) idx++;
      else idx = 0;
      update();
    };

    slider.addEventListener("mousedown", dragStart);
    slider.addEventListener("mousemove", dragMove);
    slider.addEventListener("mouseup", dragEnd);
    slider.addEventListener("mouseleave", dragEnd);
    slider.addEventListener("touchstart", dragStart, { passive: true });
    slider.addEventListener("touchmove", dragMove, { passive: true });
    slider.addEventListener("touchend", dragEnd);

    slider.addEventListener("mouseenter", stop);
    slider.addEventListener("mouseleave", start);

    window.addEventListener("resize", update);
    update();
    start();

    return () => {
      stop();
      window.removeEventListener("resize", update);
    };
  }, []);

  return (
    <>
      {/* Header */}
      <header>
        <div className="container">
          <div className="header-inner">
            <div className="header-logo" style={{ display: "flex", alignItems: "center", gap: "12px" }}>
              <a href="https://nab.gov.pk" className="nab-link">
                <img  style={{width:'80px'}} src="/images/nab_logo.png" className="img-logo" alt="NAB Logo" />
              </a>
              <span
                className="bureau-title"
                style={{
                    fontWeight: "bold", // or use 700
                    fontSize: "22px",
                    color: "#222"
                }}
                >
                National Accountability Bureau
                </span>

            </div>

            <div className="header-actions" style={{ display: "flex", alignItems: "center", gap: "12px" }}>
            <a
                href="https://nab.gov.pk/"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                    border: "1px solid #555",
                    padding: "8px 16px",
                    borderRadius: "4px",
                    textDecoration: "none",
                    fontSize: "14px",
                    color: "#333",
                    fontWeight: "500",
                    lineHeight: "1",
                    height: "40px",
                    display: "none",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: "transparent",

                }}
                >
                Comment
                </a>

              <Button
                  as={Link}
                  to="/housing-scheme-verification"
                  style={{
                    backgroundColor: '#06416C',
                    borderColor: '#06416C',
                    borderRadius: '8px',
                    fontWeight: 600,
                    padding: '6px 18px',
                  }}
                  onMouseOver={(e) => (e.target.style.backgroundColor = '#083a5b')}
                  onMouseOut={(e) => (e.target.style.backgroundColor = '#06416C')}
              >
             Property Verification
              </Button>

                <div className="navbar-nav flex-row align-items-center">
                {isLoggedIn ? (
                  <button
                  onClick={handleLoginRedirect}
                  style={{
                    backgroundColor: "#004080",
                    color: "#fff",
                    padding: "8px 16px",
                    borderRadius: "4px",
                    fontSize: "14px",
                    fontWeight: "500",
                    lineHeight: "1",
                    height: "40px",
                    border: "none",
                    cursor: "pointer",
                    display:'none'
                  }}
                >
                  Map
                </button>
                ) : (
                  <button
                    onClick={handleLoginRedirect}
                    style={{
                      backgroundColor: "#004080",
                      color: "#fff",
                      padding: "8px 16px",
                      borderRadius: "4px",
                      fontSize: "14px",
                      fontWeight: "500",
                      lineHeight: "1",
                      height: "40px",
                      border: "none",
                      cursor: "pointer",
                      display:'none'
                    }}
                  >
                    Login/Register
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </header>

      {/* Main */}
      <main>
        {/* Banner Section */}
        <section className="main-section">
          <div className="main-bg" style={{ position: "relative" }}>
            <div className="main-slider">
              <div className="slide-item active">
                <img src="/images/Frame_english.png" className="bg-img" alt="Nab" />
              </div>
              <div className="slide-item">
                <img src="/images/Frame_urdu.png" className="bg-img" alt="Nab" />
              </div>
            </div>
            <div className="slider-indicators">
              <span className="indicator active"></span>
              <span className="indicator"></span>
            </div>
          </div>
        </section>

        {/* Steps Section */}
        <section className="second-section">
          <div className="container">
            <h2>How To Use OPIS Report</h2>
            <div className="report-flow">
              {[1, 2, 3, 4].map((step, i) => (
                <div className={`step step-${i + 1}`} key={i}>
                  <div className="step-img-box">
                    <img src={`/images/step-${step}.png`} className="step-img" alt={`Step ${i + 1}`} />
                  </div>
                  <div className="step-text">
                  <h3 style={{ textAlign: "center" }}>
                    {i === 0
                        ? (
                        <>
                            <span>Go to</span>  <br />
                            <span style={{ display: "inline-block" }}>property.nab.gov.pk</span>
                        </>
                        )
                        : ["Search for a\n" +
                        "housing scheme", "Click on the\n" +
                        "housing scheme", "View the approved\n" +
                        "housing scheme layout"][i - 1]
                    }
                    </h3>

                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Map Section */}
        <section className="third-sectionHome">
          <img src="/images/Nab_pak_map_new.svg" className="img-map map-new-img" alt="Nab Islamabad Map" />
        </section>

        {/* Collaborators Section */}
      <section className="four-section">
        <div className="container">
          <h2>Our Collaborators</h2>
          <div className="authority-carousel-wrapper">
            <button className="carousel-btn prev">&#10094;</button>
            <div className="authority-slider">
              {[
                ["cda.svg", "https://www.cda.gov.pk/", "Capital Development Authority"],
                ["rda.svg", "https://rda.gop.pk", "Rawalpindi Development Authority"],
                ["lda.svg", "https://lda.gop.pk", "Lahore Development Authority"],
                ["pda.svg", "https://pda.kp.gov.pk/", "Peshawar Development Authority"],
                ["kda.svg", "https://www.kda.gos.pk/", "Karachi Development Authority"],
                ["pata-c.svg", "https://phata.punjab.gov.pk/", "Punjab Housing & Town Planning Agency"],
                ["fda-c.svg", "https://www.fda.gov.pk/", "Faisalabad Development Authority"],
                ["gda-c.svg", "https://gda.punjab.gov.pk/", "Gujranwala Development Authority"],
                ["sba-c.svg", "https://www.sbca.gos.pk/", "Sindh Building Control Authority"],

              ].map(([img, link, name], i) => (
                <a
                  href={link}
                  key={i}
                  className="auth-item"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ textDecoration: "none", color: "inherit" }}
                >
                  <div className="auth-img-box">
                    <img className="auth-logo" src={`/images/${img}`} alt={name} />
                  </div>
                  <div className="auth-text">
                    <h4>{name}</h4>
                  </div>
                </a>
              ))}
            </div>
            <button className="carousel-btn next">&#10095;</button>
          </div>
        </div>
      </section>

      </main>

      {/* Footer */}
      <footer style={{ background: "#f5f5f5", padding: "40px 0" }}>
        <div className="container">
          <div className="footer-inner" style={{ display: "flex", flexWrap: "wrap", justifyContent: "space-between", gap: "20px" }}>
            <div className="footer-col footer-1" style={{ flex: "1 1 220px" }}>
              <div className="footer-logo">
                <a href="https://nab.gov.pk" className="nab-link">
                  <img src="/images/nab_logo.png" className="nab-logo" alt="NAB Logo" style={{ maxWidth: "160px", height: "auto" ,     marginTop: "-28px" }} />
                </a>
              </div>
            </div>

            <div className="footer-col footer-2 footer-menu-section" style={{ flex: "1 1 220px" }}>
              <ul className="footer-menu">
                <li>
                  <a href="tel:+92519207799" className="menu-link">
                    <i className="fas fa-phone"></i> <span>051-9207799</span>
                  </a>
                </li>
                <li style={{display:'none'}}>
                  <a href="mailto:webmaster@nab.gov.pk" className="menu-link">
                    <i className="fas fa-envelope"></i> <span>webmaster@nab.gov.pk</span>
                  </a>
                </li>
              </ul>
            </div>

            <div className="footer-col footer-3 footer-menu-section" style={{ flex: "1 1 280px" }}>
              <h3>Address</h3>
              <ul className="footer-menu">
                <li>
                  <a href="https://maps.app.goo.gl/waWsP6Y2uhUbnude6" className="menu-link" target="_blank" rel="noopener noreferrer">
                    <i className="fas fa-map-marker-alt"></i>
                    <span>
                      National Accountability Bureau (NAB), Shahrah‑e‑Jamhuriat, G‑5/1, Islamabad.
                    </span>
                  </a>
                </li>
              </ul>
            </div>

            <div className="footer-col footer-4 footer-menu-section" style={{ flex: "1 1 220px" }}>
              <h3>For Complaint</h3>
              <ul className="footer-menu">
                <li><a href="tel:+92111622622" className="menu-link">UAN: 111‑622‑622</a></li>
                <li style={{display:'none'}}><a href="mailto:chairman@nab.gov.pk" className="menu-link">Email: chairman@nab.gov.pk</a></li>
                <li><a href="https://nab.gov.pk/online-complaint/" className="menu-link" target="_blank" rel="noopener noreferrer">Online Complaint Registration</a></li>
              </ul>
            </div>
          </div>
        </div>
      </footer>

     {/* <PopupComponent/>*/}
    </>
  );
};

export default HomePage;
